module.exports = __webpack_public_path__ + "79f27dfed6a71c1807f65d41515f3865.svg";